import { formatSalesValue } from "../../../utils/formatUtils";

const CostingTable = ({ data, type, calculatePercentage, formatNumber }) => {
    const toNumber = (val) => parseFloat(val) || 0;

    const salesItems = data?.sales_summary?.items_sold || [];
    // const purchaseItems = data?.purchase_items?.deployed_items || [];

    const totalItems = salesItems.length;

    const missingItemsCount = salesItems.filter(
        i => !toNumber(i.unit_cost)
    ).length;

    const accuracy =
        totalItems > 0
            ? (((totalItems - missingItemsCount) / totalItems) * 100).toFixed(2)
            : 0;

    const summary = data?.sales_summary || {};

    return (
        <div className="border p-2 space-y-6">
            <div>
                <div className="font-semibold mb-1 text-sm text-center uppercase tracking-wider">
                    {type}
                </div>

                <div className="rounded-md border overflow-x-auto max-h-[275px] mb-2 tiny-scrollbar">
                    <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-center">
                        <thead className="bg-gray-100 top-0 sticky z-10">
                            <tr>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    Item Name
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    Qty
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    Sale
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    Unit Cost
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    CP (%)
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    Total Cost
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-100">
                            {salesItems.length > 0 ? (
                                salesItems.map((item, i) => (
                                    <tr key={i} className="hover:bg-gray-50 tracking-wide">
                                        <td className="px-2 py-1">{item.item_name}</td>

                                        <td className="px-2 py-1">
                                            {formatNumber(item.quantity)}
                                        </td>

                                        <td className="px-2 py-1">
                                            {formatSalesValue(item.total_sale)}
                                        </td>

                                        <td className="px-2 py-1">
                                            {formatSalesValue(item.unit_cost)}
                                        </td>

                                        <td className="px-2 py-1">
                                            {item.total_sale && item.total_cost
                                                ? calculatePercentage(
                                                    Math.abs(parseFloat(item.total_cost)),
                                                    parseFloat(item.total_sale)
                                                )
                                                : "N/A"}
                                        </td>

                                        <td className="px-2 py-1">
                                            {formatSalesValue(
                                                Math.abs(item.total_cost)
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={6}
                                        className="px-3 py-4 text-gray-500 text-center"
                                    >
                                        No costing data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* SUMMARY */}
                <div className="grid grid-cols-2 gap-16 font-semibold px-2 tracking-wide">
                    <div>
                        <div className="grid grid-cols-2 gap-x-2 gap-y-1 items-center">
                            <label>Total items:</label>
                            <input
                                readOnly
                                value={totalItems}
                                className="border p-1 rounded w-full text-center"
                            />

                            <label>Missing items:</label>
                            <input
                                readOnly
                                value={missingItemsCount}
                                className="border p-1 rounded w-full text-center"
                            />

                            <label>Accuracy:</label>
                            <input
                                readOnly
                                value={`${accuracy}%`}
                                className={`border p-1 rounded w-full text-center ${accuracy < 80
                                    ? "bg-red-200 text-red-800"
                                    : accuracy <= 90
                                        ? "bg-yellow-200 text-yellow-800"
                                        : "bg-green-200 text-green-800"
                                    }`}
                            />

                            <label>Discount:</label>
                            <input
                                readOnly
                                value={formatSalesValue(summary?.discount)}
                                className="border p-1 rounded w-full text-center"
                            />

                            <label>Complementary:</label>
                            <input
                                readOnly
                                value={formatSalesValue(summary?.complementary)}
                                className="border p-1 rounded w-full text-center"
                            />
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-x-2 gap-y-1 items-center">
                        <label>Gross Cost:</label>
                        <input
                            readOnly
                            value={formatSalesValue(summary?.gross_cost)}
                            className="border p-1 rounded w-full text-center"
                        />

                        <label>Gross Sale:</label>
                        <input
                            readOnly
                            value={formatSalesValue(summary?.gross_sale)}
                            className="border p-1 rounded w-full text-center"
                        />

                        <label>Gross Cost %:</label>
                        <input
                            readOnly
                            value={
                                summary?.gross_cost_percent
                                    ? summary.gross_cost_percent + "%"
                                    : "0.00%"
                            }
                            className="border p-1 rounded w-full text-center"
                        />

                        <label>Net Sale:</label>
                        <input
                            readOnly
                            value={formatSalesValue(summary?.net_sale)}
                            className="border p-1 rounded w-full text-center"
                        />

                        <label>Net Cost % from Sales:</label>
                        <input
                            readOnly
                            value={
                                data.net_cost_percent
                                    ? Number(data.net_cost_percent).toFixed(2) + "%"
                                    : "0.00%"
                            }
                            className="border p-1 rounded w-full text-center"
                        />
                    </div>
                </div>
            </div>

            {/* PURCHASE SECTION */}
            {/* <div>
                <h3 className="font-semibold text-center text-sm mb-1.5 uppercase tracking-wider">
                    {type} ITEMS PURCHASED
                </h3>

                <div className="rounded-md border overflow-x-auto max-h-[275px] tiny-scrollbar">
                    <table className="min-w-full divide-y divide-gray-200 text-center">
                        <thead className="bg-gray-100 top-0 sticky z-10">
                            <tr>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    ITEM
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    AMT
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    UOM
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    RATE
                                </th>
                                <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                    TOTAL
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-100">
                            {purchaseItems.length > 0 ? (
                                purchaseItems.map((item, i) => (
                                    <tr key={i} className="hover:bg-gray-50">
                                        <td className="px-2 py-1">{item.item_name}</td>
                                        <td className="px-2 py-1">
                                            {item.total_quantity}
                                        </td>
                                        <td className="px-2 py-1">{item.uom}</td>
                                        <td className="px-2 py-1">
                                            {formatSalesValue(item.average_rate)}
                                        </td>
                                        <td className="px-2 py-1">
                                            {formatSalesValue(item.total_amount)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={5}
                                        className="px-3 py-4 text-gray-500 text-center"
                                    >
                                        No purchase data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 px-2 flex gap-3 justify-end items-center">
                    <label className="font-semibold">
                        Total {type} Purchase:
                    </label>
                    <input
                        readOnly
                        value={formatSalesValue(
                            data?.purchase_items?.summary?.total_value || 0
                        )}
                        className="border p-1 rounded w-40 text-center"
                    />
                </div>
            </div> */}
        </div>
    );
};

export default CostingTable;